import React from 'react';

import { StyledIconButton } from './icon-button.styles';

export function IconButton(props) {
  return <StyledIconButton data-testid={props.automationId} {...props} disableRipple />;
}
